/**
 * Dependency-free stable hash for trigger dedup keys (FNV-1a, 64-bit via two
 * 32-bit lanes). Dedup needs stability and low collision odds, not
 * cryptographic strength — and this module is exported from the core root
 * barrel, which must stay browser-safe (no node:crypto).
 */
export function stableHash(input: string): string {
  let h1 = 0x811c9dc5;
  let h2 = 0xcbf29ce4;
  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 0x01000193) >>> 0;
    h2 = Math.imul(h2 ^ c, 0x01000197) >>> 0;
  }
  return h1.toString(16).padStart(8, '0') + h2.toString(16).padStart(8, '0');
}
